import React from 'react';
import ColorTipsImg from '../../../assets/img/color_tips.png';
import { useStyles } from './style';
import { Close } from '@material-ui/icons';

export interface ColorTipsPopupProps {
    onClose: () => any;
}

const ColorTipsPopup = (props: ColorTipsPopupProps) => {
    const { onClose } = props;
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <div className={classes.main}>
                <div className={classes.padContainer} onClick={onClose}></div>
                <div className={classes.contentPage}>
                    <div className={classes.itemsTitle}>
                        <div className={classes.itemsTitleText}>Color Tips</div>
                        <Close className={classes.itemsTitleIcon} onClick={onClose} />
                    </div>
                    <div className={classes.body}>
                        <div className={classes.contentTitle}>Type Dark Winter</div>
                        <div className={classes.imageContainer}>
                            <img src={ColorTipsImg} className={classes.image} alt={''} />
                        </div>
                        <div className={classes.contentDescription}>
                            The Winter palette is cool, clear, vivid and high contrast. The only palette with true white
                            and black in it, it also features the strongest variants of red, green, pink and blue. If
                            you've been given a designation within the Winter palette, let's explore what that means for
                            you.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ColorTipsPopup;
